$('.slide').slick({
    infinite: true,
  arrows: false,
  swipe: false,
  dots: false,
  variableWidth: true,  // スライド幅の自動計算を無効
  autoplay: true,
  autoplaySpeed: 0,
  speed: 9000,
  cssEase: "linear",
});